import { render, staticRenderFns } from "./mainmenu.vue?vue&type=template&id=c2b5f32e&"
import script from "./mainmenu.vue?vue&type=script&lang=js&"
export * from "./mainmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports